export default __webpack_public_path__ + "static/media/cardano.62aa81df.svg";